import React, { useState } from 'react';
import Button from '../common/Button'; // Importando o componente de botão
import { db } from '../../firebase'; // Firestore configurado
import {
  collection,
  getDocs,
  deleteDoc,
  doc,
  where,
  query,
} from 'firebase/firestore';
import { useAuthState } from 'react-firebase-hooks/auth';
import { auth } from '../../firebase'; // Mantendo a configuração atual do auth
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import MessageModal from '../modals/MessageModal'; // Importando o modal de confirmação

const ConfiguracoesGerais = () => {
  const [notificacoesEmail, setNotificacoesEmail] = useState(true);
  const [notificacoesSMS, setNotificacoesSMS] = useState(false);
  const [user] = useAuthState(auth); // Mantendo a autenticação do usuário
  const [isDeleting, setIsDeleting] = useState(false); // Mantendo o estado de exclusão
  const [isConfirmHistoricoModalOpen, setIsConfirmHistoricoModalOpen] =
    useState(false); // Estado para controle do modal de exclusão de histórico
  const [isConfirmAgendamentosModalOpen, setIsConfirmAgendamentosModalOpen] =
    useState(false); // Estado para controle do modal de exclusão de agendamentos
  const [isDeletingAgendamentos, setIsDeletingAgendamentos] = useState(false); // Estado de exclusão de agendamentos

  // Função para excluir o histórico de atendimentos do usuário logado
  const handleDeleteHistorico = async () => {
    if (!user) return;

    setIsDeleting(true);

    try {
      const atendimentosRef = collection(db, 'atendimentos');
      const q = query(atendimentosRef, where('userId', '==', user.uid));
      const querySnapshot = await getDocs(q);

      querySnapshot.forEach(async (docSnapshot) => {
        await deleteDoc(doc(db, 'atendimentos', docSnapshot.id));
      });

      toast.success('Histórico de atendimentos excluído com sucesso!');
    } catch (error) {
      console.error('Erro ao excluir histórico:', error);
      toast.error('Erro ao excluir o histórico de atendimentos.');
    } finally {
      setIsDeleting(false);
      setIsConfirmHistoricoModalOpen(false); // Fecha o modal após a exclusão
    }
  };

  // Função para excluir todos os agendamentos
  const handleDeleteAgendamentos = async () => {
    if (!user) return;

    setIsDeletingAgendamentos(true);

    try {
      const agendamentosRef = collection(db, 'agenda');
      const q = query(agendamentosRef, where('userId', '==', user.uid));
      const querySnapshot = await getDocs(q);

      querySnapshot.forEach(async (docSnapshot) => {
        await deleteDoc(doc(db, 'agenda', docSnapshot.id));
      });

      toast.success('Todos os agendamentos excluídos com sucesso!');
    } catch (error) {
      console.error('Erro ao excluir agendamentos:', error);
      toast.error('Erro ao excluir os agendamentos.');
    } finally {
      setIsDeletingAgendamentos(false);
      setIsConfirmAgendamentosModalOpen(false); // Fecha o modal após a exclusão
    }
  };

  const handleSaveConfig = (e) => {
    e.preventDefault();
  };

  // Função para abrir o modal de confirmação de histórico
  const handleOpenHistoricoConfirmModal = () => {
    setIsConfirmHistoricoModalOpen(true);
  };

  // Função para abrir o modal de confirmação de agendamentos
  const handleOpenAgendamentosConfirmModal = () => {
    setIsConfirmAgendamentosModalOpen(true);
  };

  // Função para fechar o modal de confirmação
  const handleCloseConfirmModal = () => {
    setIsConfirmHistoricoModalOpen(false);
    setIsConfirmAgendamentosModalOpen(false);
  };

  return (
    <>
      <ToastContainer />
      <form
        onSubmit={handleSaveConfig}
        className="max-w-lg mx-auto p-6 bg-white rounded-lg space-y-6"
      >
        <h2 className="font-semibold text-gray-800">Configurações Gerais</h2>

        <div className="space-y-4">
          <div className="flex items-center">
            <input
              type="checkbox"
              checked={notificacoesEmail}
              onChange={() => setNotificacoesEmail(!notificacoesEmail)}
              className="w-4 h-4"
            />
            <label className="ml-2 text-gray-700">Notificações por Email</label>
          </div>

          <div className="flex items-center">
            <input
              type="checkbox"
              checked={notificacoesSMS}
              onChange={() => setNotificacoesSMS(!notificacoesSMS)}
              className="w-4 h-4"
            />
            <label className="ml-2 text-gray-700">Notificações por SMS</label>
          </div>
        </div>

        <div className="space-y-4">
          <Button
            type="salvar"
            label="Salvar Configurações"
            onClick={handleSaveConfig}
            className="w-full"
          />

          <Button
            type="remover"
            label={
              isDeleting ? 'Excluindo...' : 'Excluir Histórico de Atendimentos'
            }
            onClick={handleOpenHistoricoConfirmModal} // Abre o modal de confirmação de histórico
            className="w-full"
            disabled={isDeleting}
          />

          <Button
            type="remover"
            label={
              isDeletingAgendamentos
                ? 'Excluindo...'
                : 'Excluir Todos os Agendamentos'
            }
            onClick={handleOpenAgendamentosConfirmModal} // Abre o modal de confirmação de agendamentos
            className="w-full"
            disabled={isDeletingAgendamentos}
          />
        </div>
      </form>

      {/* Modal de Confirmação para excluir o histórico de atendimentos */}
      {isConfirmHistoricoModalOpen && (
        <MessageModal
          isOpen={isConfirmHistoricoModalOpen}
          onClose={handleCloseConfirmModal}
          onConfirm={handleDeleteHistorico} // Executa a exclusão ao confirmar
          title="Confirmar Exclusão"
          message="Tem certeza que deseja excluir o histórico de atendimentos? Esta ação não pode ser desfeita."
          ariaLabel="Modal de confirmação para excluir o histórico de atendimentos"
        />
      )}

      {/* Modal de Confirmação para excluir todos os agendamentos */}
      {isConfirmAgendamentosModalOpen && (
        <MessageModal
          isOpen={isConfirmAgendamentosModalOpen}
          onClose={handleCloseConfirmModal}
          onConfirm={handleDeleteAgendamentos} // Executa a exclusão ao confirmar
          title="Confirmar Exclusão"
          message="Tem certeza que deseja excluir todos os agendamentos? Esta ação não pode ser desfeita."
          ariaLabel="Modal de confirmação para excluir todos os agendamentos"
        />
      )}
    </>
  );
};

export default ConfiguracoesGerais;
